import { useNavigate, useParams } from "react-router-dom";
import VODDeliveryEditForm from "../components/vod-delivery/delivery-edit-form";
import { useFeatureFlagQuery } from "../hasura.graphql";

const VODDeliveryByIdEdit = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const role_data = useFeatureFlagQuery();

  return (
    <>
      {role_data.data?.feature_flag.find(
        (feat) => feat.feature === "channel-edit"
      ) !== undefined ? (
        <VODDeliveryEditForm
          close={() => navigate(`/deliveries/vod-deliveries/${id}`)}
          deliveryId={id!}
          isModal={false}
        />
      ) : (
        navigate(`/deliveries/vod-deliveries/${id}`)
      )}
    </>
  );
};

export default VODDeliveryByIdEdit;
